import React, { memo } from 'react';
import styles from './Triangle.module.less';

export default memo(({ data: { color = '#FF4A4A', cornerText } }) => {
  return (
    <>
      {cornerText && (
        <div className={styles.triangle}>
          <i className="iconfont icon-label" style={{ color, fontSize: '70px' }} />
          <div className={styles.text}>{cornerText}</div>
        </div>
      )}
    </>
  );
});
